import axios from 'axios';
import api from '../utilities/api';
import Users from '../schemas/public/Users';
import { API_URL } from '../config';

export const getUser = async (token: string): Promise<Users | null> => {
    try {
        const response = await api.get('/user?include=establishment', {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data as Users;
    } catch {
        return null;
    }
};

export const saveUser = async (user: Users, token: string): Promise<Users | null> => {
    const userData = {
        user: {
            firstName: user.firstName,
            lastName: user.lastName,
            dob: user.dob,
            gender: user.gender,
            profilePicture: user.profilePicture,
            relationship: user.relationship,
            profession: user.profession,
        },
    };
    try {
        const response = await api.post('/user/', userData, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data as Users;
    } catch {
        return null;
    }
};

export const getFamilyMembers = async (token: string): Promise<Users[]> => {
    try {
        const response = await api.get('/family/', {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data as Users[];
    } catch {
        return [];
    }
};

export const getBeneficiaryMembers = async (token: string): Promise<Users[]> => {
    try {
        const response = await api.get('/user/beneficiary-into-family', {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data as Users[];
    } catch {
        return [];
    }
};

export const checkEmail = async (email: string): Promise<boolean> => {
    try {
        const response = await axios.get(`${API_URL}/if-user-exist?email=${email}`);
        return response.data as boolean;
    } catch {
        return false;
    }
};

export const deleteUser = async (token: string): Promise<boolean> => {
    try {
        const response = await api.get('/user/delete-user', {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data as boolean;
    } catch {
        return false;
    }
};

export const getUserById = async (token: string, id: string): Promise<Users | null> => {
    try {
        const response = await api.get(`/user/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data[0] as Users;
    } catch {
        return null;
    }
};
